export const formateCoctailDefaultValues = (data: any) => {
  const result = {};

  for (const lang in data) {
    const langData = data[lang];

    for (const key in langData) {
      const newKey = `${lang}_${key}`;
      result[newKey] = langData[key];
    }
  }

  return result;
};
